import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "32",
      height: "32",
      fill: "#0057B8",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "square",
      "stroke-width": "1.5",
      d: "m24 24-5.333-5.333M8 14.222a6.223 6.223 0 1 0 12.446 0 6.223 6.223 0 0 0-12.446 0Z"
    }, null, -1)
  ]))]))
}
export default { render: render }